import $ from "jquery";
import React, { Suspense, useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import UserBasicInfoContext from '../../../components/Context/UserBasicInfoContext';


import { SUPER_ADMIN } from "../ConstRole/ConstRole";
import BankList from "./Bank/BankList";
import BranchList from "./Branch/BranchList";


const BankBranch = () => {
    const [currentTab, setCurrentTab] = useState("Bank");
    const userProfile = useContext(UserBasicInfoContext);

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    
    const { state } = useLocation();
    useEffect(() => {

        if ((state?.tab !== null && state?.tab !== undefined && state?.tab !== "")) {
            if (state?.tab === "Bank") {
                $(".tablinks").eq(1).trigger("click");
            }
        }

    }, [state]);


    if (userProfile.user_type !==  SUPER_ADMIN ) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }



    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">

            
        {/* TAB SWITCHER */}
        <div className="tab w-full">
            <button className="tablinks current" onClick={(event) => handleTab("Bank", event)}>Bank</button>
            <button className="tablinks" onClick={(event) => handleTab("Branch", event)}>Branch</button>
        </div>

        <div className='tabcontentbody py-3 px-0'>
            <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px", paddingRight: "0px" }}>
                <Suspense fallback="Loading...">

                    {(() => {
                        switch (currentTab) {
                            case "Bank":
                                return <BankList />;
                            case "Branch":
                                return <BranchList />;
                            default:
                                return <>No page found</>;
                        }
                    })()}

                </Suspense>
            </div>
        </div>

                


            <style>{`
                .custom-scroll-auto { 
                    overflow-x: hidden;
                }

                .tab button:hover::after, .tab button.current::after { 
                    width: 120% !important;
                    margin-left: -10% !important;
                }
                `}</style>


        </div>
    );
};

export default BankBranch;